export const DEFAULT_CONTAINER_STATE = {
  NONE: ''
}

export const CLAIM_PROCESS_STEP = {
  CLAIM: 'claim',
  CLAIM_TAP: 'claimTap',
  CLAIMED_VIR: 'claimedVir',
  CLAIM_STAKING: 'claimStaking',
  SUCCESS: 'success'
}
